import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../context/auth-context.jsx';
import { adminApi } from '../../../lib/admin-api/index.js';
import { buildPartnersRequestDto, mapPartnersResponseToDto } from '../dto/partners-list.dto.js';
import { buildPartnersTableModel } from '../model/partners-list.model.js';

export function usePartnersList() {
  const { token } = useAuth();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const loadPartners = useCallback(async (filters = {}) => {
    setIsLoading(true);
    setError('');
    try {
      const response = await adminApi.getPartners(token, buildPartnersRequestDto(filters));
      const dto = mapPartnersResponseToDto(response);
      setRows(buildPartnersTableModel(dto));
    } catch (requestError) {
      setRows([]);
      setError(requestError.message || 'Failed to load partners');
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    loadPartners({ status: statusFilter });
  }, [loadPartners, statusFilter]);

  const onStatusFilterChange = useCallback((value) => {
    setStatusFilter(value);
  }, []);

  const toggleFilter = useCallback(() => {
    setIsFilterOpen((prev) => !prev);
  }, []);

  const resetFilters = useCallback(() => {
    setStatusFilter('');
    setIsFilterOpen(false);
  }, []);

  const reload = useCallback(() => {
    loadPartners({ status: statusFilter });
  }, [loadPartners, statusFilter]);

  return {
    rows, isLoading, error, statusFilter, isFilterOpen,
    onStatusFilterChange, toggleFilter, resetFilters, reload,
  };
}
